import React from "react";
import { getIn } from "formik";
import { isMobile } from "react-device-detect";
import { HiOutlineInformationCircle} from "react-icons/hi";
import {
  TextField,
  Box,
  Typography,
  FormControlLabel,
  FormControl,
  FormGroup,
  Checkbox,
  InputAdornment,
  useTheme,
  Grid,
  Tooltip,
  Icon,
} from "@material-ui/core";

const Step2 = ({
  Formdata,
  showPassword,
  setshowPassword,
  checkTenantAvailability,
  checkRedeemAvailability,
  redemptionCodeAvailable,
  tenantCodeAvailable,
  showRedemptionCode

}) => {
  const pathname = window.location.pathname;
  const appsumoUrl = pathname.includes("appsumo");

  const theme = useTheme();
  return (
    <>
      <TextField
        required
        fullWidth
        name={`userName`}
        label="Full Name"
        value={Formdata.values.userName}
        onBlur={(e) => {
          Formdata.handleBlur(e);
        }}
        onChange={(e) => {
          Formdata.handleChange(e);
        }}
        variant="outlined"
        size="small"
        helperText={
          getIn(Formdata.touched, `userName`) &&
          getIn(Formdata.errors, `userName`)
        }
        error={
          Boolean(getIn(Formdata.errors, `userName`)) &&
          getIn(Formdata.touched, `userName`)
        }
      />
      <TextField
        required
        fullWidth
        name={`companyName`}
        value={Formdata.values.companyName}
        label="Company Name"
        onBlur={(e) => {
          Formdata.handleBlur(e);
          if(Formdata.values.tenantCode === ""){
            checkTenantAvailability(e.target.value.replace(" ", "").toLowerCase());
            Formdata.setFieldValue("tenantCode", e.target.value.replace(" ", ""))
          }
        }}
        onChange={(e) => {
          Formdata.handleChange(e);
          }}
        helperText={
          getIn(Formdata.touched, `companyName`) &&
          getIn(Formdata.errors, `companyName`)
        }
        error={
          Boolean(getIn(Formdata.errors, `companyName`)) &&
          getIn(Formdata.touched, `companyName`)
        }
        variant="outlined"
        size="small"
      />
      <Grid container direction="row" spacing={1} alignItems="center">
        <Grid item 
         xs={isMobile ? 12 : 11}>
        <TextField
        required
        fullWidth
        label="Domain name"
        placeholder="Create your domain"
        name={`tenantCode`}
        value={Formdata.values.tenantCode.toLowerCase()}
        onBlur={(e) => {
          if (e.target.value !== "") {
            checkTenantAvailability(e.target.value.toLowerCase());
          }
          Formdata.handleBlur(e);
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">.growmax.store</InputAdornment>
          ),
        }}
        onChange={(e) => {
          if (e.target.value !== "") {
            checkTenantAvailability(e.target.value.toLowerCase());
          }
          Formdata.handleChange(e);
        }}
        variant="outlined"
        helperText={
          (Boolean(tenantCodeAvailable) && "Tenant code not available") ||
          (getIn(Formdata.touched, `tenantCode`) &&
            getIn(Formdata.errors, `tenantCode`))
        }
        FormHelperTextProps={{
          style: {
            color:
              !(
                (Boolean(tenantCodeAvailable) &&
                  "Tenant code not available") ||
                (getIn(Formdata.touched, `tenantCode`) &&
                  getIn(Formdata.errors, `tenantCode`))
              ) && theme.palette.primary.dark,
          },
        }}
        error={
          (Boolean(tenantCodeAvailable) && "Tenant code not available") ||
          (Boolean(getIn(Formdata.errors, `tenantCode`)) &&
            getIn(Formdata.touched, `tenantCode`))
        }
        size="small"
      />
        </Grid>
        { !isMobile ?
        <Grid xs={1}>
      
<Box ml={0.5} alignItems="center" display="flex">
        <Tooltip arrow title="Domain name can be edited">
          <Icon fontSize="small">
          <HiOutlineInformationCircle/>
          </Icon>
        </Tooltip>
      </Box>
      </Grid>
: null
        
      }
      </Grid>
     
      {showRedemptionCode ?
  <TextField
  fullWidth
  label="Redemption code"
  placeholder="Enter your redemption code"
  name={`redemption`}
  value={Formdata.values.redemption || ""}
  onKeyPress={(e) => {
    if (appsumoUrl) {
       checkRedeemAvailability(e.target.value);
    }
    Formdata.handleBlur(e);
  }}
  onBlur={(e) => {
    if (appsumoUrl) {
       checkRedeemAvailability(e.target.value);
    }
    Formdata.handleBlur(e);
    
  }}
  variant="outlined"
  onChange={(e) => {
    if (e.target.value !== "" && appsumoUrl) {
      checkRedeemAvailability(e.target.value);
    }
    Formdata.handleChange(e);
  }}
  
  size="small"
  required={window.location.pathname.includes("appsumo")}
  helperText={
    (Boolean(redemptionCodeAvailable) &&
      "Please enter a valid code") ||
    (getIn(Formdata.touched, `redemption`) &&
      getIn(Formdata.errors, `redemption`))
  }
  FormHelperTextProps={{
    style: {
      color:
        !(
          (Boolean(redemptionCodeAvailable) &&
            "Please enter a valid code") ||
          (getIn(Formdata.touched, `redemption`) &&
            getIn(Formdata.errors, `redemption`))
        ) && theme.palette.primary.dark,
    },
  }}
  error={
    (Boolean(redemptionCodeAvailable) &&
      "Please enter a valid code") ||
    (Boolean(getIn(Formdata.errors, `redemption`)) &&
      getIn(Formdata.touched, `redemption`))
  }
/>
      :
null
      }
    
      <FormControl component="fieldset">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={Formdata.values.IsDemoRequired}
                fontSize="small"
                name="IsDemoRequired"
                onChange={Formdata.handleChange}
              />
            }
            label={
              <Typography fullwidth variant="caption">
                I would like to schedule a consultation & demo
              </Typography>
            }
          />
        </FormGroup>
      </FormControl>
      <Box mt={1}>
        <Typography variant="caption" align="center">
          By submitting this form, you agree to the&nbsp;
          <a
            href="https://www.growmax.io/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          &nbsp;and&nbsp;
          <a
            href="https://www.growmax.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </Typography>
      </Box>
    </>
  );
};

export default Step2;
